/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BDUpdateType,
    BDUpdateTypeFromJSON,
    BDUpdateTypeFromJSONTyped,
    BDUpdateTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface ActivityLogView
 */
export interface ActivityLogView {
    /**
     * 
     * @type {string}
     * @memberof ActivityLogView
     */
    userName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ActivityLogView
     */
    updatedDate?: Date;
    /**
     * 
     * @type {BDUpdateType}
     * @memberof ActivityLogView
     */
    actionType?: BDUpdateType;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogView
     */
    entityName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogView
     */
    editEntityLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActivityLogView
     */
    entityInfo?: string | null;
}

export function ActivityLogViewFromJSON(json: any): ActivityLogView {
    return ActivityLogViewFromJSONTyped(json, false);
}

export function ActivityLogViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityLogView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'updatedDate': !exists(json, 'updatedDate') ? undefined : (new Date(json['updatedDate'])),
        'actionType': !exists(json, 'actionType') ? undefined : BDUpdateTypeFromJSON(json['actionType']),
        'entityName': !exists(json, 'entityName') ? undefined : json['entityName'],
        'editEntityLink': !exists(json, 'editEntityLink') ? undefined : json['editEntityLink'],
        'entityInfo': !exists(json, 'entityInfo') ? undefined : json['entityInfo'],
    };
}

export function ActivityLogViewToJSON(value?: ActivityLogView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userName': value.userName,
        'updatedDate': value.updatedDate === undefined ? undefined : (value.updatedDate.toISOString()),
        'actionType': BDUpdateTypeToJSON(value.actionType),
        'entityName': value.entityName,
        'editEntityLink': value.editEntityLink,
        'entityInfo': value.entityInfo,
    };
}


